<template>
  <div class="c-listbody">
    <div class="c-listbody__head">
      <h4 class="c-listbody__title">{{areaName}}{{kind(proplist.kind)}}一戸建て購入情報 <span class="c-listbody__redText">{{proplist.count}}件</span></h4>
      <a class="c-listbody__more" :href="areaPath">すべて見る</a>
    </div>
    <ul class="c-listbody__list">
      <li class="c-listbody__item" v-for="(card, cardIndex) in proplist.list" :key="cardIndex">
        <common-property-card :propdata="card.fields" :isFavorite="true" :mode="mode" />
      </li>
    </ul>
    <a class="c-listbody__moreSp" :href="areaPath">{{areaName}}{{kind(proplist.kind)}}一戸建てをすべて見る</a>
  </div>
</template>

<script>
import CommonPropertyCard from '@/components/parts/CommonPropertyCard';
import MixinAPIs from '@/plugins/mixin-api';

export default {
  name: 'SearchSugguestListBody',
  props: ['proplist', 'mode'],
  mixins: [MixinAPIs],
  components: {
    CommonPropertyCard,

  },
  data() {
    return {
      url: '',
      pref_name: '',
      city_name: '',
      town_name: '',
      areaPath: '',
      areaName: '',
    };
  },
  async created() {
    this.areaPath = `/kodate/${this.kindMeta}area/`;
    const rawPref = await this.getPrefectureList(1, this.proplist.kind);
    this.pref_name = rawPref.filter(n => n.pref_code === this.proplist.pref_code)[0].pref_name;
    this.areaPath += `${this.proplist.pref_code}/`;
    if (this.proplist.city_code !== 0) {
      const rawCity = await this.getCityList(1, this.proplist.pref_code, this.proplist.kind);
      this.city_name = rawCity.filter(n => n.city_code === this.proplist.city_code)[0].city_name;
      this.areaPath += `${this.proplist.city_code}/`;
    }
    if (this.proplist.town_code !== 0) {
      const rawTown = await this.getTownList(1, this.proplist.city_code, this.proplist.kind);
      this.town_name = rawTown.filter(n => n.town_code === this.proplist.town_code)[0].town_name;
      this.areaPath += `${this.proplist.town_code}/`;
    }
    this.areaName = `${this.pref_name} ${this.city_name} ${this.town_name} `;
  },
  computed: {
    kindMeta() {
      let ret;
      switch (this.proplist.kind) {
        case 1:
          ret = 'shinchiku/';
          break;
        case 2:
          ret = 'chuko/';
          break;
        default:
          ret = '';
          break;
      }
      return ret;
    },
  },
  methods: {
    kind() {
      let ret;
      switch (this.proplist.kind) {
        case 1:
          ret = '新築';
          break;
        case 2:
          ret = '中古';
          break;
        default:
          ret = '';
          break;
      }
      return ret;
    },

  },
};

</script>

<style scoped lang="scss">
.c-listbody {
  &__head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
  }
  &__title {
    font-size: 16px;
    font-weight: bold;
    line-height: 1.6;
  }
  &__redText {
    font-size: 16px;
    color: #E83532;
  }
  &__more {
    display: flex;
    align-items: center;
    font-size: 14px;
    line-height: 1.4;
    word-break: keep-all;
    margin-left: 12px;

    &:hover {
      opacity: 0.8;
      text-decoration: underline;
    }
  }
  &__list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  &__item {
    width: calc(50% - 8px);
    margin-top: 10px;

    &:nth-child(odd) {
      margin-right: 4px;
    }
    &:nth-child(even) {
      margin-left: 4px;
    }
    &:nth-child(n + 3) {
      display: none;
    }
  }
  &__moreSp {
    display: none;
  }
}
@media screen and (max-width: 767px) {
  .c-listbody {
    &__item {
      width: 100%;
      margin-top: 0;
      margin-bottom: 20px;

      &:nth-child(odd) {
        margin-right: 0;
      }
      &:nth-child(even) {
        margin-left: 0;
      }
      &:nth-child(n + 3) {
        display: block;
      }
      &:nth-child(n + 4) {
        display: none;
      }
    }
    &__more {
      display: none;
    }
    &__moreSp {
      display: flex;
      justify-content: center;
    }
  }
}
</style>
